
import React from 'react';
import { PortfolioImage } from '@/hooks/useProfile';

interface ImageCaptionProps {
  currentImage: PortfolioImage | undefined;
}

const ImageCaption = ({ currentImage }: ImageCaptionProps) => {
  if (!currentImage || !currentImage.caption) {
    return null;
  }

  return (
    <div className="bg-muted/20 p-4 text-sm italic rounded-md border-l-3 border-primary/30">
      {currentImage.caption}
    </div>
  );
};

export default ImageCaption;
